type HistoryLoadMoreProps = {
  hasMore: boolean;
  onLoadMore: () => void;
};

export const HistoryLoadMore = ({ hasMore, onLoadMore }: HistoryLoadMoreProps) => {
  if (!hasMore) return null;

  return (
    <div className="px-6 py-4 border-t border-[#E5E7EB]">
      <button
        type="button"
        onClick={onLoadMore}
        className="w-full py-2 text-center font-termina text-sm font-medium text-[#026857] hover:text-[#025247] transition-colors"
      >
        Load More
      </button>
    </div>
  );
};

